import { useFilterDate } from "@/common/hooks/useFilterDate";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { MetaResponse } from "@/common/types/metaResponse";
import { formatDate, formatDateRange } from "@/common/utils/formatters";
import { ParsedBranchesEquipmentsConsumptionsTotalizerData } from "@/features/movementsTotalizer/types/branchesEquipmentsConsumptionsTotalizer.type";
import BranchesEquipmentsConsumptionsTotalizerTable from "./table/BranchesEquipmentsConsumptionsTotalizerTable";

interface BranchesEquipmentsConsumptionsTotalizerPrintProps {
  data: ParsedBranchesEquipmentsConsumptionsTotalizerData[] | undefined;
  meta: MetaResponse | undefined;
}

const BranchesEquipmentsConsumptionsTotalizerPrint = ({
  data,
  meta,
}: BranchesEquipmentsConsumptionsTotalizerPrintProps) => {
  const {
    filterParams,
  } = useFilterParams();

  const { date } = useFilterDate(filterParams);

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex flex-col">
        <div className="flex items-center justify-between">
          <p className="text-lg font-bold">
            Totalizadores de consumo de equipamentos por filial
          </p>

          <img
            src="/tcard-logo.png"
            className="h-5"
          />
        </div>

        {date && (
          <div>
            <p className="italic text-sm font-light">
              {date.from && date.to
                ? formatDateRange(new Date(date.from), new Date(date.to))
                : date.from
                  ? formatDate(new Date(date.from))
                  : date.to && formatDate(new Date(date.to))}
            </p>
          </div>
        )}
      </div>

      <BranchesEquipmentsConsumptionsTotalizerTable
        print
        data={data}
        meta={meta}
      />
    </div>
  );
}

export default BranchesEquipmentsConsumptionsTotalizerPrint;
